import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createCheckoutSession } from '../../store/actions/payments';
import { ModalComponent } from 'src/components';
import { PlanSelection } from './PlanSelection';
import { StripeCheckout } from './StripeCheckout';
import { setSession } from '../../store/slices/payments';
import './UpgradeModal.scss';
import { useAuth } from '@frontegg/react';
import { listPractitioners } from 'src/store/actions/practitioner.action';
import { analytics } from 'src/services';

export const UpgradeModal = ({ isVisible, setIsVisible }) => {
  const dispatch = useDispatch();
  const { session } = useSelector((state) => state?.paymentsState);
  const [showStripeCheckout, setShowStripeCheckout] = useState(false);
  const [plan, setPlan] = useState(null);
  const [billingCycle, setBillingCycle] = useState('annual');
  const [quantity, setQuantity] = useState(1);

  const { user } = useAuth();

  useEffect(() => {
    dispatch(listPractitioners());
  }, [dispatch]);

  useEffect(() => {
    if (!session?.client_secret && isVisible && showStripeCheckout) {
      dispatch(createCheckoutSession(plan, quantity, billingCycle));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, session, isVisible, showStripeCheckout]);

  const handleCancel = () => {
    analytics.track('Clicked Cancel In Upgrade', { email: user?.email });
    setIsVisible(false);
    setShowStripeCheckout(false);
    dispatch(setSession(null));
  };

  const handleContinue = ({ plan, quantity, billingCycle }) => {
    analytics.track(
      `Clicked Make Payment In Upgrade To ${plan} ${billingCycle}`,
      {
        email: user?.email,
      }
    );
    setPlan(plan);
    setQuantity(quantity);
    setBillingCycle(billingCycle);
    setShowStripeCheckout(true);
  };

  return (
    <ModalComponent
      centered={true}
      open={isVisible}
      handleSubmit={''}
      handleCancel={handleCancel}
      className="upgrade-to-pro"
      submitButtonText=""
      cancelButtonText=""
      closable={true}
      width={1200}
      additionalBody={
        <div className="p-4">
          {!showStripeCheckout ? (
            <PlanSelection
              handleContinue={handleContinue}
              plan={plan}
              setPlan={setPlan}
              billingCycle={billingCycle}
              setBillingCycle={setBillingCycle}
              quantity={quantity}
              setQuantity={setQuantity}
            />
          ) : (
            <StripeCheckout
              clientSecret={session?.client_secret}
              plan={plan}
              billingCycle={billingCycle}
            />
          )}
        </div>
      }
    />
  );
};
